<template>
  <div
    class="relative min-h-screen overflow-y-scroll bg-white dark:bg-kekkle-dark"
  >
    <div class="px-2">
      <router-view />
    </div>
  </div>

  <!-- Member Profile Bottom Sheet -->
  <MemberProfileBottomSheet
    v-model:open="isOpen"
    :member-id="selectedMemberId"
  />
</template>

<script>
import MemberProfileBottomSheet from "../components/MemberProfileBottomSheet.vue";
import { useMemberProfile } from "@/composables/useMemberProfile";

export default {
  name: "SinglePageLayout",
  components: { MemberProfileBottomSheet },
  setup() {
    const { isOpen, selectedMemberId } = useMemberProfile();
    return { isOpen, selectedMemberId };
  },
};
</script>
